(function () {
  var RV_KEY = 'crochiah_rv_products';
  var RV_ROOT = document.getElementById('crochiah-rv-section');
  var CURRENT_ID = RV_ROOT ? RV_ROOT.dataset.productId : '';

  function init() {
    try {
      var products = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      products = products.filter(function (p) { return p.id !== CURRENT_ID; });
      if (products.length < 1) return;

      var grid = document.getElementById('crochiah-rv-grid');
      var section = document.getElementById('crochiah-rv-section');
      if (!grid || !section) return;

      var html = '';
      var limit = Math.min(products.length, 4);
      for (var i = 0; i < limit; i++) {
        var p = products[i];
        html += '<a href="' + p.url + '" class="crochiah-rv-card">';
        if (p.image) {
          html += '<div class="crochiah-rv-img-wrap">';
          html += '<img src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" width="400" height="500" class="crochiah-rv-img" loading="lazy">';
          html += '<\/div>';
        }
        html += '<div>';
        html += '<p class="crochiah-rv-name">' + p.title + '<\/p>';
        html += '<p class="crochiah-rv-price">' + p.price_formatted + '<\/p>';
        html += '<\/div>';
        html += '<\/a>';
      }

      grid.innerHTML = html;
      section.style.display = '';
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
